const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/cvs/v1frontend/cvs-store/search', {
      params: {
        ...params,
        s: params && params.s ? params.s.replace('臺', '台') : ''
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
